import { render, staticRenderFns } from "./CompraMes.vue?vue&type=template&id=6f826c8a&"
import script from "./CompraMes.vue?vue&type=script&lang=js&"
export * from "./CompraMes.vue?vue&type=script&lang=js&"
import style0 from "./CompraMes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports